import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface FooterProps {
  className?: string
  compact?: boolean
}

/**
 * Footer component with legal links (Privacy Policy, Terms of Service).
 * Displays disclaimer text and links to legal documents.
 *
 * TODO: Convert markdown links to rendered pages. Currently links to raw .md files
 * which browsers display as plain text. Options:
 * - Use react-markdown to render inline
 * - Create dedicated routes (/privacy, /terms) with markdown rendering
 * - Pre-compile .md to .html at build time
 */
export function Footer({ className, compact = false }: FooterProps) {
  const { t } = useTranslation()

  return (
    <footer
      className={cn(
        'border-t border-neutral-200 bg-neutral-50/80 backdrop-blur-sm',
        'text-center text-xs text-neutral-500',
        compact ? 'py-3' : 'py-6',
        className
      )}
    >
      <div className="px-4 space-y-2">
        {/* Disclaimer */}
        {!compact && (
          <p className="text-[10px] text-neutral-400 max-w-md mx-auto">
            {t('footer.disclaimer')}
          </p>
        )}

        {/* Copyright */}
        <p className="text-[10px] text-neutral-400">
          © {new Date().getFullYear()} Tricorder GmbH
        </p>
      </div>
    </footer>
  )
}
